/*
 * @Author: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2024-04-24 11:40:16
 * @LastEditors: YTH
 * @LastEditTime: 2025-10-22 11:14:16
 * @FilePath: \hszy-official-website\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'default-passive-events'

import './styles/normal.scss'
import './styles/element-variables.scss'
import 'normalize.css/normalize.css'
import 'animate.css/animate.min.css'
import '@/assets/font/Arial-BoldMT.css'
import '@/assets/font/PangMenZhengDao-3.css'
import '@/assets/font/SourceHanSansCN-Normal.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
